module.exports = __webpack_public_path__ + "static/energy_22-5d766ed1ac03706fc1cb3126103ab635.jpg";